import { Component, OnDestroy, OnInit } from '@angular/core';

import { NavController, Platform } from '@ionic/angular';
import { AuthActions, AuthService, IAuthAction } from 'ionic-appauth-custom';
import { NavigationService } from './navigation.service';
import { LocalNotificationsService } from './local-notifications.service';
import { FactOfTheDayService } from './fact-of-the-day.service';
import { UserService } from './user.service';
import { ConnectivityService } from './connectivity.service';
import { CheckSigninService } from './auth/check-signin.service';
import {Subscription} from 'rxjs';
import {LaunchTrackerService} from './trackers/launch-tracker.service';
import {StatusBar} from '@awesome-cordova-plugins/status-bar/ngx';
import {SplashScreen} from "@capacitor/splash-screen";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  public appPages = [];
  public labels = [];
  sub: Subscription;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private auth: AuthService,
    private navCtrl: NavController,
    public navigationService: NavigationService,
    private localNotifs: LocalNotificationsService,
    private userService: UserService,
    private factOfTheDayService: FactOfTheDayService,
    private connectivityService: ConnectivityService,
    private checkSignInService: CheckSigninService,
    private launchTrackerService: LaunchTrackerService // is injected to start the service on app start
  ) {
    this.initializeApp();
    this.appPages = navigationService.appPages;
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      console.log('Initizalize App!');
      SplashScreen.hide().then();
      await this.auth.init();
      this.statusBar.styleDefault();
      this.checkSignInService.runStartupAnimation = true;
      this.platform.resume.subscribe(() => {this.onAppResume(); });
    });
  }

  ngOnInit() {
    this.sub = this.auth.events$.subscribe((action) => this.onSignOutSuccess(action));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private onSignOutSuccess(action: IAuthAction) {
    if (action.action === AuthActions.SignOutSuccess) {
      this.navCtrl.navigateRoot('landing').then();
    }
  }

  private onAppResume(): void {
    console.log('App was resumed!');
    this.checkSignInService.startLoginProcess(false, true);
    this.checkReminders();
    this.factOfTheDayService.update();
    if (this.userService.user) { this.userService.user.checkAutofill(); }
    this.connectivityService.triggerAuthChecks().then();
  }

  private checkReminders(): void {
    // Log which notifications are scheduled right now
    // LocalNotifications.getScheduledIds().then(id => { //also for testing
    //   console.log ("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@All scheduled IDs " + JSON.stringify(id)); //
    // });
    // Make sure reminder notifications are scheduled
    this.localNotifs.checkDailyReminders().then();
    this.localNotifs.checkMealReminders().then();
  }

  public signOut() {
    console.log('App component signout triggered');
    this.auth.signOut().then();
  }

  public refreshToken(): void {
    this.auth.refreshToken().then();
  }
}
